<template>
  <v-card elevation="16" variant="outlined" class="mx-auto my-8">
    <v-card-item>
      <v-card-title>Création d'une fiche medecin</v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-chip-group>
              <v-chip :class="classHo" color="blue" @click="civility('Homme')">Homme
              </v-chip>
              <v-chip :class="classFe" color="pink" @click="civility('Femme')"> Femme
              </v-chip>
            </v-chip-group>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4">
              <v-text-field variant="outlined" label="Nom" v-model="data.nom" :rules="[rules.required]"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field variant="outlined" label="Prénom" v-model="data.prenom"
                :rules="[rules.required]"></v-text-field>
            </v-col>


            <v-col cols="6" sm="4">
              <v-text-field variant="outlined" label="Téléphone" v-model="data.tel"
                placeholder="Numero de Téléphone du patient"></v-text-field>
            </v-col>
            <v-col cols="6" sm="4">
              <v-text-field variant="outlined" label="Email" v-model="data.email"
                :rules="[rules.required]"></v-text-field>
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field variant="outlined" label="Adresse" v-model="data.adresse"></v-text-field>
            </v-col>
          </v-row>


          <v-row justify="center" v-if="isNotView()">
            <v-btn @click="valider()" variant="elevated" label="Valider" route to="/ListMedecin" color="blue-darken-4"
              class="text-none ms-4 text-white" :disabled="!isValid()">Valider</v-btn>
            <v-btn @click="this.$router.push('/ListMedecin');" variant="elevated" color="red-darken-4"
              class="text-none ms-4 text-white" label="Annuler">Annuler</v-btn>

          </v-row>
        </v-container>
      </v-card-text>
    </v-card-item>
  </v-card>
  <!-- </v-expansion-panel>

</v-expansion-panels>  -->
</template> 
<script>

import http from '../http.js';

export default {

  data: () => ({
    rules: {
      required: value => !!value || "Le champ est obligatoire",
    },
    classHo: null,
    classFe: null,
    classH: "v-chip v-chip--link v-theme--light text-blue v-chip--density-default v-chip--size-default v-chip--variant-tonal v-chip--selected",
    classF: "v-chip v-chip--link v-theme--light text-pink v-chip--density-default v-chip--size-default v-chip--variant-tonal v-chip--selected",

    class: "v-chip v-chip--link v-theme--light v-chip--density-default v-chip--size-default v-chip--variant-tonal",
    form: false,
    email: null,
    idPatient: null,
    password: null,
    loading: false,
    disable: false,
    data: {}

  }),
  mounted() {
    if (this.$route.name == 'viewPatient') {
      this.disable = true
    } else {
      this.disable = false;
    }
    this.idPatient = this.$route.params.id

    if (this.$route.params.id != undefined) {

      //  .get("/api/patient/"+this.$route.params.id).then(resp=>this.data=resp.data);

      http.get("/api/medecin/" + this.$route.params.id).then(resp => { this.data = resp.data; if (this.data.civilite == 'Homme') { this.classHo = this.classH } else this.classFe = this.classF });

    }

  },

  methods: {
    valider() {

      http.post("/api/medecin", this.data)
      // .then( this.$router.push('/medecin'));
    },
    civility(item) {
      this.data.civilite = item;
      if (item == "Homme") {
        return this.classFe = this.class;
      }
      if (item == "Femme") {
        return this.classHo = this.class;
      }

    },
    afficherTab() {
      return true
    },
    getId() {
      return this.$route.params.id;
    },
    isNotView() {

      return this.$route.name != 'viewMedecin'
    },
    isValid() {
      return this.data.nom != undefined
        && this.data.prenom != undefined
        && this.data.email != undefined;
    },
  }

}
</script>